export default __webpack_public_path__ + "static/media/linked-lot.e89c469a.svg";